import { useEffect, useRef, useState } from 'react';

interface UseElementSizeProps {
  enabled?: boolean;
}

export const useElementSize = <T extends HTMLElement = HTMLDivElement>(
  { enabled }: UseElementSizeProps = { enabled: true }
) => {
  const ref = useRef<T>(null);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (!ref.current || !enabled) return;

    const observer = new ResizeObserver(([entry]) => {
      const { width, height } = entry.contentRect;
      setWidth(width);
      setHeight(height);
    });

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [enabled]);

  return { ref, width, height };
};
